var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 666,
    viewBox: "0 0 749 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4558_546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 549,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.621 549.329H233.021V607.604H532.621V549.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4558_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.688 602.934C453.857 602.934 511.55 545.222 511.55 474.03C511.55 402.838 453.857 345.125 382.688 345.125C311.52 345.125 253.827 402.838 253.827 474.03C253.827 545.222 311.52 602.934 382.688 602.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.021 547.248H532.622",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.538 127.053L149.869 225.423C139.915 234.868 139.5 250.597 148.942 260.554L358.653 481.711C368.095 491.668 383.819 492.083 393.772 482.638L497.442 384.267C507.396 374.822 507.811 359.094 498.369 349.137L288.658 127.98C279.216 118.023 263.492 117.608 253.538 127.053Z",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.477 207.701L237.743 167.595C238.842 166.552 240.579 166.598 241.621 167.698C242.664 168.797 242.618 170.534 241.519 171.577L199.254 211.682C198.154 212.725 196.418 212.68 195.375 211.58C194.332 210.48 194.378 208.743 195.477 207.701Z",
    fill: "#343239",
    stroke: "#343239",
    strokeWidth: 2.68142
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490.548 144.204L331.97 294.902C320.735 305.579 320.279 323.345 330.953 334.584L415.207 423.303C425.88 434.542 443.641 434.998 454.876 424.321L613.454 273.623C624.689 262.946 625.145 245.18 614.471 233.941L530.217 145.222C519.544 133.983 501.784 133.527 490.548 144.204Z",
    fill: "#E4E2E2",
    stroke: "#343239",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.548 144.204L331.97 294.902C320.735 305.579 320.279 323.345 330.953 334.584L415.207 423.303C425.88 434.542 443.641 434.998 454.876 424.321L613.454 273.623C624.689 262.946 625.145 245.18 614.471 233.941L530.217 145.222C519.544 133.983 501.784 133.527 490.548 144.204Z",
    fill: "#F7F3F3",
    stroke: "#343239",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.527 379.362L488.044 314.252",
    stroke: "#343239",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M433.488 394.058L479.165 350.65",
    stroke: "#343239",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.534 340.143L395.359 359.965C399.144 363.951 405.443 364.113 409.428 360.326L437.304 333.835C441.289 330.048 441.451 323.747 437.665 319.761L418.841 299.939C415.055 295.953 408.756 295.791 404.771 299.578L376.895 326.069C372.91 329.856 372.749 336.157 376.534 340.143Z",
    fill: "#E8E8E8",
    stroke: "#343239",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M385.741 319.57L416.369 351.823",
    stroke: "#343239",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M426.547 338.318L407.403 318.16L419.494 306.67",
    stroke: "#343239",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M426.547 338.319L418.891 330.256L430.979 318.765",
    stroke: "#343239",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M394.712 353.237L406.803 341.747",
    stroke: "#343239",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M383.22 341.14L395.311 329.65",
    stroke: "#343239",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M453.317 220.875L456.364 217.948C456.901 218.465 457.544 218.353 458.388 217.543C459.337 216.631 459.329 216.011 458.914 215.579C458.267 214.905 457.468 215.551 456.378 216.316C454.773 217.452 452.13 219.323 449.783 216.88C447.811 214.827 448.049 211.825 450.58 209.394C453.111 206.963 456.088 206.917 457.89 208.688L454.885 211.575C454.345 211.182 453.681 211.314 453.07 211.901C452.311 212.631 452.368 213.324 452.763 213.735C453.36 214.356 454.169 213.721 455.259 212.956C456.927 211.759 459.537 210.001 461.843 212.402C463.856 214.497 463.471 217.558 460.856 220.07C458.241 222.583 455.209 222.803 453.296 220.896L453.317 220.875Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M462.317 210.448L452.952 200.698L456.041 197.73L459.5 201.331L464.319 196.702L466.989 199.481L462.17 204.111L465.407 207.48C466.439 208.554 467.248 208.404 467.923 207.756C468.598 207.107 468.78 206.305 467.748 205.231L467.455 204.926L470.544 201.958L470.837 202.263C473.619 205.158 473.215 208.199 470.684 210.63C468.153 213.061 465.099 213.343 462.317 210.448V210.448Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M470.214 199.461C467.17 196.292 467.609 193.035 470.33 190.422C473.05 187.808 476.291 187.509 479.376 190.7L479.437 190.763L476.347 193.731L476.267 193.647C474.962 192.288 473.945 192.475 473.081 193.306C472.216 194.137 471.988 195.145 473.293 196.503L478.846 202.283L475.756 205.251L470.203 199.471L470.214 199.461Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M486.777 196.547L489.867 193.579C490.82 193.959 491.621 193.716 492.612 192.764C493.972 191.457 493.956 190.238 492.48 188.7L491.509 187.69C491.778 189.131 491.348 190.456 490.283 191.479C488.142 193.535 484.468 194.291 480.898 190.574L476.003 185.478L479.092 182.51L483.987 187.606C485.525 189.207 486.963 189.141 488.122 188.027C489.282 186.913 489.375 185.447 487.868 183.879L482.973 178.783L486.062 175.815L495.478 185.617C498.877 189.155 497.975 192.754 495.202 195.418C492.798 197.728 489.732 198.547 486.798 196.527L486.777 196.547Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M487.254 174.67L490.565 171.489L499.739 176.544L495.057 167.174L498.294 164.064L504.406 177.729L500.662 181.325L487.254 174.67V174.67Z",
    fill: "#1A1A1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M503.169 169.139C500.205 166.054 500.298 161.613 503.503 158.534C506.709 155.454 511.098 155.591 514.061 158.676L514.891 159.539L507.214 166.913C508.6 167.87 510.022 167.536 511.14 166.462C512.026 165.611 512.498 164.794 512.372 163.861L515.567 160.792C516.926 163.515 516.331 166.78 513.801 169.211C510.584 172.3 506.153 172.204 503.19 169.119L503.169 169.139ZM509.846 160.64C508.486 159.922 507.229 160.259 506.153 161.292C505.078 162.325 504.71 163.589 505.396 164.915L509.846 160.64Z",
    fill: "#1A1A1A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.484 244.115L446.241 238.584C448.909 236.021 449.008 231.776 446.439 229.102L437.417 219.71C436.179 223.086 436.417 226.056 438.792 231.103C441.424 236.714 441.572 240.498 440.494 244.125L440.484 244.115Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M434.848 220.012L425.801 228.703C423.133 231.266 423.034 235.511 425.603 238.185L432.208 245.06C434.955 241.187 434.898 237.962 433.964 233.17C432.693 226.738 432.728 224.559 434.848 220.012V220.012Z",
    fill: "#1A1A1A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M263.663 244.56L275.065 233.607C280.348 228.532 280.543 220.126 275.456 214.83L257.589 196.231C255.138 202.916 255.609 208.798 260.312 218.793C265.524 229.903 265.818 237.399 263.683 244.581L263.663 244.56Z",
    fill: "#1A1A1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M252.502 196.828L234.585 214.039C229.302 219.115 229.106 227.521 234.194 232.817L247.273 246.433C252.713 238.762 252.6 232.375 250.751 222.885C248.234 210.149 248.303 205.833 252.502 196.828V196.828Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness1);
export default __webpack_public_path__ + "static/media/business-1.9f86a428bccfb1e416988f2ce8b17cfc.svg";
export { ForwardRef as ReactComponent };